export default function validate(formProps) {
    const errors = {};

    if (!formProps.faq_type_id) {
        errors.faq_type_id = 'FAQ Type is required! Please select a type for your FAQ!';
    }

    if (!formProps.title) {
        errors.title = 'Title field is required! Please enter a title for your FAQ!';
    } else if (formProps.title && formProps.title.length < 5) {
        errors.title = 'Please enter a minimum of 5 characters!';
    }

    if (!formProps.body) {
        errors.body = 'FAQ body content is required! Please enter a body content for your FAQ!';
    }

    return errors;
}


// WEBPACK FOOTER //
// ./src/containers/faqs/forms/validation.js